import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';

export const QRCodeScreen: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const playerUrl = `${window.location.origin}/battle-royale/player/${sessionId}`;

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        bgcolor: '#365964',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            linear-gradient(rgba(255, 255, 255, 0.2) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.2) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
          pointerEvents: 'none'
        }
      }}
    >
      {/* ヘッダー */}
      <Box
        sx={{
          position: 'absolute',
          top: 20,
          left: 40,
          color: 'white'
        }}
      >
        <Typography variant="h6">
          Player Registration
        </Typography>
      </Box>

      <Box
        sx={{
          position: 'absolute',
          top: 20,
          right: 40,
          color: 'white'
        }}
      >
        <Typography variant="h6">
          NAZOTOKI KOSHOKAI
        </Typography>
      </Box>

      {/* メインコンテンツ */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'center',
            mb: 2
          }}
        >
          プレイヤー参加用 QRコード
        </Typography>

        <Box
          sx={{
            bgcolor: 'white',
            p: 6,
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
          }}
        >
          <QRCodeCanvas
            value={playerUrl}
            size={400}
            level="M"
            includeMargin={false}
          />
        </Box>

        <Typography
          variant="h4"
          sx={{
            color: 'white',
            textAlign: 'center',
            mt: 2
          }}
        >
          スマートフォンでQRコードを読み取って参加
        </Typography>

        <Box
          sx={{
            bgcolor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: 2,
            px: 4,
            py: 2,
            mt: 2
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: 'white',
              fontFamily: 'monospace',
              fontSize: '1.2rem'
            }}
          >
            {playerUrl}
          </Typography>
        </Box>
      </Box>

      {/* フッター */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 20,
          left: 40,
          color: 'white'
        }}
      >
        <Typography variant="body1">
          NAZOTOKI BATTLE ROYAL
        </Typography>
      </Box>

      {/* 装飾的な要素 */}
      <Box
        sx={{
          position: 'absolute',
          top: 60,
          left: 60,
          width: 40,
          height: 40,
          border: '2px solid white',
          borderBottom: 'none',
          borderRight: 'none'
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 60,
          right: 60,
          width: 40,
          height: 40,
          border: '2px solid white',
          borderBottom: 'none',
          borderLeft: 'none'
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 60,
          left: 60,
          width: 40,
          height: 40,
          border: '2px solid white',
          borderTop: 'none',
          borderRight: 'none'
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 60,
          right: 60,
          width: 40,
          height: 40,
          border: '2px solid white',
          borderTop: 'none',
          borderLeft: 'none'
        }}
      />
    </Box>
  );
};